run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','report'];

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,report) {
  MenuConstant[0]['menu'].push(report);
}


// WEBPACK FOOTER //
// ./src/app/u-faculty/report/report.run.js